import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IGenericModal} from '@shared/components/generic-modal/generic-modal';

@Component({
    selector: 'oct-generic-modal',
    templateUrl: './generic-modal.component.html',
    styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent {
    constructor(
        public dialogRef: MatDialogRef<GenericModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IGenericModal,
    ) {
    }

    close() {
        this.dialogRef.close();
    }
}
